//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { Opaque } from '@utils/opaque';

/**
 * Unique identifier for an active sampling campaign
 * This ID is used to identify a campaign that has been approved and is in its active/execution phase
 * Example of a campaign id: 153614
 */
export type SamplingCampaignId = Opaque<number, 'SamplingCampaignId'>;

function SamplingCampaignIdFactory(campaignId: number): SamplingCampaignId {
  return campaignId as SamplingCampaignId;
}

export { SamplingCampaignIdFactory };
